import React from 'react';
import classNames from 'classnames';
import get from 'lodash.get';
import i18next from 'i18next';
import { content as ContentPropType } from 'lib/CustomPropTypes';
import { Footer } from './Footer';
import { Header } from './Header';
import { MsnbcDailyArticles } from './MsnbcDailyArticles';
import { MsnbcDailyAuthors } from './MsnbcDailyAuthors';
import styles from './MsnbcDailyArticles/styles.module.scss';


function MsnbcDaily({ content: { articlesPackage, authorsPackage, id } }) {
  const headerTitle = get(articlesPackage, ['metadata', 'title']);
  const headerTitleUrl = get(articlesPackage, ['metadata', 'titleUrl']);
  const headerDescription = get(articlesPackage, ['metadata', 'description']);

  const articles = get(articlesPackage, ['items'], []);
  const showFeature = get(articlesPackage, ['metadata', 'showFeature'], true);
  const showFeatureNumbered = get(articlesPackage, ['metadata', 'showFeatureNumbered'], false);
  const showFeaturePublishedDate = get(articlesPackage, ['metadata', 'showFeaturePublishedDate'], false);

  const authorsArticles = get(authorsPackage, ['items'], []);
  const authorsHeading = get(authorsPackage, ['metadata', 'title'], i18next.t('Latest from MSNBC Contributors'));
  const seeAllText = get(authorsPackage, ['metadata', 'seeAllText']);
  const seeAllUrl = get(authorsPackage, ['metadata', 'seeAllUrl']);
  const actionButtonText = get(authorsPackage, ['metadata', 'actionButtonText'], i18next.t('Subscribe to MSNBC Daily'));
  const actionButtonUrl = get(authorsPackage, ['metadata', 'actionButtonUrl'], 'https://www.msnbc.com/daily-subscribe');
  const infoText = get(authorsPackage, ['metadata', 'infoText'], i18next.t('Like this content? Follow our rundown delivered daily right to your inbox'));

  if (articles.length === 0 || authorsArticles.length === 0) return null;

  return (
    <div className={classNames('pkg', styles.msnbcDaily)} data-packageid={id}>
      <Header
        description={headerDescription}
        title={headerTitle}
        titleUrl={headerTitleUrl}
        t={i18next.t}
      />
      <MsnbcDailyArticles
        articles={articles}
        packageId={id}
        showFeature={showFeature}
        showFeatureNumbered={showFeatureNumbered}
        showFeaturePublishedDate={showFeaturePublishedDate}
      />
      <MsnbcDailyAuthors
        content={
          {
            items: authorsArticles,
            cardType: 'author',
          }
        }
        title={authorsHeading}
        vertical="msnbc"
        seeAllText={seeAllText}
        seeAllUrl={seeAllUrl}
      />
      <Footer
        actionButtonText={actionButtonText}
        actionButtonUrl={actionButtonUrl}
        infoText={infoText}
      />
    </div>
  );
}

MsnbcDaily.propTypes = {
  content: ContentPropType.isRequired,
};

export { MsnbcDaily };
